import createIconComponent from '../createIconComponent.js';

/* THIS FILE IS AUTO-GENERATED */
var ChevronUpIcon = /*#__PURE__*/createIconComponent('ChevronUp', '<path fill-rule="evenodd" clip-rule="evenodd" d="M11.8447 9.93653L7.87503 13.9059C7.58212 14.1987 7.10725 14.1987 6.81437 13.9058C6.52149 13.6129 6.52151 13.138 6.81442 12.8451L11.102 8.55795C11.2989 8.36104 11.5663 8.25 11.8447 8.25C12.1232 8.25 12.3902 8.36064 12.587 8.55755L16.875 12.8451C17.1679 13.138 17.168 13.6129 16.8751 13.9058C16.5822 14.1987 16.1073 14.1987 15.8144 13.9059L11.8447 9.93653Z"/>');

export { ChevronUpIcon as default };
